import Vue from 'vue';
import { Modal } from 'ant-design-vue';

// 增加适合小屏幕的提示框，代替alert
Vue.prototype.$alert = (text) => {
    return Modal.confirm({
        title:`提示`,
        content:text,
        cancelButtonProps: { style: { display: 'none' } }, // 隐藏取消按钮
        okText:'确定',
        cancelText:null,
        width:250,
        centered:true,
    })
}